import React from "react";
import "./Link.scss";
import { IMediaElement } from "../../../types/IMediaElement";

export default function Link({ id, className, href, target, children, onClick }: IMediaElement) {
    return <a id={id} className={className} href={href} target={target} onClick={onClick}>{children}</a>;
}